__turbopack_context__.v({
  "article": "BlogArticle-module-scss-module__RiWvMG__article",
  "blog-article": "BlogArticle-module-scss-module__RiWvMG__blog-article",
  "blog-nav": "BlogArticle-module-scss-module__RiWvMG__blog-nav",
  "breadcrumbs": "BlogArticle-module-scss-module__RiWvMG__breadcrumbs",
  "hero": "BlogArticle-module-scss-module__RiWvMG__hero",
  "more-articles": "BlogArticle-module-scss-module__RiWvMG__more-articles",
});
